module.exports = __webpack_public_path__ + "static/media/dany_specification_en.ef7e6642.md";